import Immutable from 'immutable';

const Message = Immutable.Record({
  user: '',
  type: 'unknown',
  url: '',

  id: null,
  body: '',
  createdAt: null,
  trackingId: null,
  sessionId: null,
  campaignId: null,
  failed: false,
  loading: false,
  inputAt: null,
  promptAt: null,
  sentBy: {
    id: null,
    type: null,
  },
  attachments: null,
});

export const CompanyMessage = ({ sessionId, body, id = '__team', promptAt = new Date().toISOString() }) =>
  Message({
    sessionId,
    body,
    id,
    promptAt, // needed for volume control form

    // do not set these
    createdAt: null,
    trackingId: '__none',
    failed: false,
    loading: false,
    sentBy: {
      id: '__team',
      type: 'user',
    },
  });

export const TempUserMessage = ({ sessionId, body, id, inputAt = new Date().toISOString() }) =>
  Message({
    sessionId,
    body,
    id,
    inputAt, // needed for volume control form

    createdAt: null,
    failed: false,
    loading: false,
    sentBy: {
      id,
      type: 'customer',
    },
  });

export default Message;
